import moment from "moment-timezone";

export const getReportByType = ({ reports, type }) => {
  for (const report of reports) {
    if (report?.file_sub_type === type) {
      return report;
    }
  }

  return null;
};

export const getMultipleReports = (reports, fileSubType) => {
  return reports
    .filter((report) => report.file_sub_type === fileSubType)
    .sort((a, b) => moment.utc(b.timestamp) - moment.utc(a.timestamp));
};
